/* eslint-disable camelcase */
import axios from 'axios'

const instance = axios.create()

// const base =
//   process.env.NODE_ENV === "production"
//     ? "https://api.scm.dumo.cloud/logistics"
//     : "http://localhost:5678"

const base = 'https://api.pointograph.com/_dev'

window.API_HOST = base

const sessionExpiredEvent = new Event('sessionExpired')
class Api {
  constructor () {
    this.token = window.getItem('token')
  }

  __jsonRequest (method, url, data = {}) {
    return instance.request({
      url,
      method,
      data: {
        ...data
      },
      headers: {
        'Content-Type': 'application/json',
        ...(this.token ? { 'x-api-token': this.token } : {})
      }
    })
  }

  __formDataRequest (method, url, data = new FormData()) {
    return instance.request({
      url,
      method,
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...(this.token ? { 'x-api-token': this.token } : {})
      }
    })
  }

  async __request (method, url, data = undefined, asFormData = false) {
    try {
      url = url.includes('http') ? url : `${base}${url}`
      const res = asFormData
        ? await this.__formDataRequest(method, url, data)
        : await this.__jsonRequest(method, url, data)
      if (res.statusCode === 401) {
        return window.dispatchEvent(sessionExpiredEvent)
      }
      if (res.data.status === 'success') {
        return res.data
      }
      return Promise.reject(res.data)
    } catch (e) {
      if (e.response) {
        return Promise.reject(e.response.data)
      }
      return Promise.reject(e)
    }
  }

  // Authentication
  setToken (token) {
    this.token = token
  }

  async login (email, password) {
    return this.__request('post', '/admin/login', {
      email,
      password
    })
  }

  //   Users
  async getUsers () {
    return this.__request('get', '/admin/users')
  }

  async activateUser (id) {
    return this.__request('post', `/admin/users/${id}/activate`)
  }

  async deactivateUser (id) {
    return this.__request('post', `/admin/users/${id}/deactivate`)
  }

  //   Pages
  async getPages () {
    return this.__request('get', '/admin/pages')
  }

  //   Places
  async getPlaces () {
    return this.__request('get', '/admin/places')
  }
}

export default new Api()
